// extracted by mini-css-extract-plugin
export default {"wrapper":"Photos_wrapper__CFCh2","avatar":"Photos_avatar__Fy0KL","avatarImg":"Photos_avatarImg__8icKm"};